const $inject = [
  '$rootScope',
  '$q',
  '$http',
  'moment',
  'APP_CONFIG',
  'locationService',
  'apiService',
  'ENUMS',
  'locationsSearchService',
  'dateTimeService',
  'settingsService',
];

const itinerariesService = function (
  $rootScope,
  $q,
  $http,
  moment,
  APP_CONFIG,
  locationService,
  apiService,
  ENUMS,
  locationsSearchService,
  dateTimeService,
  settingsService
) {
  let service = {
    itinerary: undefined,
    bookingCompleted: false,
    get,
    set,
    lazyGet,
    getItinerarySearch,
    save,
    post,
    find,
    findOffline,
    findPnr,
    findPassenger,
    reset,
    getCurrentSearch,
    getStayLength,
    searchItineraries,
    approveItinerary,
    confirmItinerary, // LOBT-2525 Frontend - My Bookings Confirm booking on hold
    declineItinerary,
    IataSearch,
    locationSearch,
    addItems,
    updateSearch,
    postSearch,
    getPolicyOptions,
    getTimePolicyOptions,
    getFlyAmericaPolicyOptions,
    setFlyAmericaEnabled,
    deleteSector,
    groupPost,
    nextStage,
    totalPaxInCurrentSearch,
    invalidSeatsForSector,
    isUsingRailCard,
    getLoyaltyPrograms,
    getCarSupplierLocationsByCityCode,
    getCarSupplierLocations,
    getFareRules,
    postMembership,
    postMemberships,
    deleteMembership,
    getApprovers,
    getCompanyReferences,
    getDepartments,
    getCostCentres,
    putFlight,
    putFlights,
    putAncillary,
    putRail,
    computePaxFlightTotalAmount,
    computePaxSectors,
    deletePax,
    computeItinerary,
    getValidated,
    postModify,
    postModifyCurrent,
    hotelPriceCheck,
    getDates,
    selectPickUpLocationByAirportCode,
    getModifyHotel,
    reeBookFailedHotel,
    getModifyCar,
    postRecentSearch,
    intlMultiCityCheck,
    intlMultiCityCheckSegments,
    repeatingCityCheckSegments,
    areSameCompanyReferences,
    setPrevNextMethods,
    getModificationsSettings,
    hasApprovalRequired,
    isModifyItinerary,
    setStayInformedOfChangesSection,
    isSameArrivalAndDeparture,
  };

  function getCurrentSearch() {
    const currentSearchType = locationService.currentSearchType;
    const currentSearchIndex = locationService.searchIndex[currentSearchType];
    return service.itinerary.Search[`${currentSearchType}s`][currentSearchIndex];
  }

  function getDates(options) {
    if (shouldGetCarSearchDates(options)) {
      return getCarSearchDates(options);
    } else {
      return getDefaultDates(options);
    }
  }

  const shouldGetCarSearchDates = (options) => {
    return (
      options &&
      options.searchType === ENUMS.itinerarySearchTypes.CAR_SEARCH &&
      service.itinerary &&
      service.itinerary.Flights &&
      service.itinerary.Flights[0]
    );
  };

  const getCarSearchDates = (options) => {
    const flights = service.itinerary.Flights;
    const arrivalDate = moment(flights[0].Arrival.Date, 'YYYY-MM-DD HH:mm:ss');
    const pickUpDate = arrivalDate.format(options.dateFormat || 'll');
    const pickUpTime = arrivalDate.format(options.timeFormat || 'h:mm a');
    let dropOffDate = pickUpDate;
    let dropOffTime = moment('5:00 PM', 'h:mm A').format(options.timeFormat || 'h:mm a');
    if (flights[1]) {
      const departureDate = moment(flights[1].Departure.Date, 'YYYY-MM-DD HH:mm:ss');
      dropOffDate = departureDate.format(options.dateFormat || 'll');
      dropOffTime = departureDate.format(options.timeFormat || 'h:mm a');
    }
    return {
      pickUpDate,
      dropOffDate,
      pickUpTime,
      dropOffTime,
    };
  };

  const getDefaultDates = (options) => {
    const pickUpTime = moment('9:00 AM', 'h:mm A')
      .add(1, 'days')
      .format(options.timeFormat || 'h:mm a');
    const dropOffTime = moment('5:00 PM', 'h:mm A')
      .add(2, 'days')
      .format(options.timeFormat || 'h:mm a');
    let pickUpDate = new Date();
    pickUpDate.setDate(pickUpDate.getDate() + 1);
    let dropOffDate = new Date();
    dropOffDate.setDate(dropOffDate.getDate() + 2);
    if (service.itinerary && service.itinerary.sectors) {
      let earliestSectorDate = service.itinerary.sectors[0].date;
      pickUpDate = moment(earliestSectorDate).format(options.dateFormat || 'll');
      dropOffDate = goForwardInTime(pickUpDate, 1, options.dateFormat || 'll');
    }
    return {
      pickUpDate,
      dropOffDate,
      pickUpTime,
      dropOffTime,
    };
  };

  function selectPickUpLocationByAirportCode() {
    const airportCode =
      service.itinerary && service.itinerary.Flights && service.itinerary.Flights.length ? service.itinerary.Flights[0].Arrival.Code : '';
    return locationsSearchService.get({ term: airportCode, maxRows: 10, searchTypes: 'Airport' }).then((searchResults) => {
      return _.find(searchResults, (option) => option.Iata === airportCode);
    });
  }

  function goForwardInTime(current, increaseBy, dateFormat) {
    if (current) {
      return moment(current, dateFormat).add(increaseBy, 'day').format(dateFormat);
    } else {
      return moment().add(increaseBy, 'day').format(dateFormat);
    }
  }

  function getStayLength(hotelSearch) {
    const checkinMoment = moment(hotelSearch.DateFrom);
    const checkoutMoment = moment(hotelSearch.DateTo);

    return checkoutMoment.diff(checkinMoment, 'days');
  }

  function getPolicyOptions() {
    return getCurrentSearch().Policy;
  }

  function getFlyAmericaPolicyOptions() {
    return getCurrentSearch().FlyAmericaActPolicies;
  }
  function setFlyAmericaEnabled() {
    let flyAmericaPolicyOptions = getCurrentSearch().FlyAmericaActPolicies;
    return flyAmericaPolicyOptions && flyAmericaPolicyOptions.length > 0;
  }

  function getTimePolicyOptions() {
    return getCurrentSearch().LessThanXDayPolicies;
  }

  // LOBT-2493 Prebooking seat javascript error
  // strange problem, that only is thrown in Chrome, getCurrentSearch().Passengers is undefined
  // when the app navigates to the seat selection page
  function totalPaxInCurrentSearch() {
    const currentSearch = getCurrentSearch();

    // we can just default the passenger length to 1, but outside of this function, some maths are applied
    // it's the passenger count * item amount for the segment, giving a total amount, which is a problem if we default to 1
    // when booking the flight, the total amount is correct, so don't know if it's just a red herring in js
    // also verifed that when you have a guest traveler, the dollar amount is correct for the two travelers
    return currentSearch !== undefined ? currentSearch.Passengers.filter((p) => !p.IsLapChild || p.IsLapChild === false).length : 1;
  }

  function updateSearch(searchType, searchIndex, search) {
    if (Number.isInteger(searchIndex)) {
      if (searchType === 'Cars' || searchType === 'Hotels' || searchType === 'GroundTransports') {
        service.itinerary.Search[searchType][searchIndex] = search;
      } else {
        _.merge(service.itinerary.Search[searchType][searchIndex], search);
      }
    } else if (_.isArray(search)) {
      updateRoundTripSearches(search);
      _.forEach(search, (newSearch, searchIndex) => {
        _.merge(service.itinerary.Search[searchType][searchIndex], newSearch);
      });
    }

    set(service.itinerary);

    return service.itinerary.Search;
  }
  function updateRoundTripSearches(search) {
    if (!(service.itinerary.Search.Flights && service.itinerary.Search.Flights.length > 1 && search.length > 1)) {
      return;
    }
    if (service.itinerary.Search.Hotels && service.itinerary.Search.Hotels.length == 1) {
      //Update Hotels
      service.itinerary.Search.Hotels[0].DateFrom = search[0].Date;
      service.itinerary.Search.Hotels[0].DateTo = search[1].Date;
      if (service.itinerary.Search.Hotels[0].Location.Code === service.itinerary.Search.Flights[0].Destination.Code) {
        service.itinerary.Search.Hotels[0].Location = {
          Code: search[0].Destination.Code,
          Type: 'Airport',
        };
      }
    }
    if (service.itinerary.Search.Cars && service.itinerary.Search.Cars.length == 1) {
      //Update Cars
      service.itinerary.Search.Cars[0] = {
        PickUp: {
          Date: search[0].Date,
          Code: search[0].Destination.Code,
        },
        DropOff: {
          Date: search[1].Date,
          Code: search[1].Origin.Code,
        },
      };
    }
  }

  function postSearch(updatedSearch) {
    let deferred = $q.defer();

    $http
      .post(`${APP_CONFIG.api.url}Itinerary/${service.itinerary.Identifier}/search`, updatedSearch)
      .then((response) => {
        const search = response.data;
        service.itinerary.Search = search;
        deferred.resolve(search);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function getItinerarySearch(itineraryId) {
    return service.lazyGet(itineraryId).then((itinerary) => itinerary.Search);
  }

  function set(itinerary, selectedItems) {
    service.itinerary = Array.isArray(itinerary) ? itinerary[0] : itinerary;
    if (
      selectedItems &&
      itinerary &&
      itinerary.Search &&
      itinerary.Search.Flights &&
      itinerary.Search.Flights.length === selectedItems.length
    ) {
      selectedItems.forEach((item, index) => {
        if (item && item.Flight) {
          itinerary.Search.Flights[index].anchoredFlight = item.Flight.Identifier;
        }
      });
    }
    sessionStorage.setItem('itineraryId', service.itinerary.Identifier);
  }

  function get(itineraryId) {
    if (!itineraryId) {
      itineraryId = getSessionItineraryId();
    }

    return fetchItinerary(itineraryId).then((itinerary) => {
      service.set(itinerary, false);
      return itinerary;
    });
  }
  function getValidated(itineraryId, clearCache) {
    if (!itineraryId) {
      itineraryId = getSessionItineraryId();
    }

    return fetchItineraryValidated(itineraryId, clearCache).then((itinerary) => {
      service.set(itinerary, false);
      return itinerary;
    });
  }

  function lazyGet(itineraryId) {
    if (!itineraryId) {
      itineraryId = getSessionItineraryId();
      if (!itineraryId) {
        return $q.reject(new Error('No Itinerary'));
      }
      if (service.itinerary && service.itinerary.Identifier === itineraryId) {
        return $q.resolve(service.itinerary);
      }
    }

    return fetchItinerary(itineraryId).then((itinerary) => {
      service.set(itinerary);
      return itinerary;
    });
  }

  function getSessionItineraryId() {
    return sessionStorage.getItem('itineraryId') || window.itineraryId;
  }

  function fetchItinerary(itineraryId) {
    const apiUrl = apiService.getUrl('itinerary', {
      itineraryId,
    });

    return $http.get(apiUrl, {}).then(({ data }) => {
      if (!data) {
        throw new Error('No Itinerary');
      }
      const itineraryData = _.isArray(data) ? data[0] : data;
      return itineraryData;
    });
  }
  function fetchItineraryValidated(itineraryId, clearCache) {
    const apiUrl = apiService.getUrl('itinerary', {
      itineraryId,
    });

    return $http.get(apiUrl + `/validate?clearCache=${clearCache}`, {}).then(({ data }) => {
      if (!data) {
        throw new Error('No Itinerary');
      }
      const itineraryData = _.isArray(data) ? data[0] : data;
      return itineraryData;
    });
  }

  function searchItineraries(params) {
    let deferred = $q.defer();

    $http
      .get(APP_CONFIG.api.itinerary, {
        params: params,
      })
      .then((response) => {
        const data = response.data;
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function post(data, id, skipNext, selectedItems) {
    let deferred = $q.defer();

    let url = id ? `${APP_CONFIG.api.itinerary}${id}` : APP_CONFIG.api.itinerary;

    $http
      .post(url, data)
      .then((response) => {
        const data = response.data;
        service.set(data, selectedItems);
        if (!skipNext) {
          nextStage(selectedItems);
        } else {
          deferred.resolve(data);
        }
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }
  function postRecentSearch(data, id, skipNext) {
    let deferred = $q.defer();

    let url = `${APP_CONFIG.api.itinerary}RecentSearch/${id}`;

    $http
      .post(url, data)
      .then((response) => {
        const data = response.data;
        service.set(data);
        if (!skipNext) {
          nextStage();
        } else {
          deferred.resolve(data);
        }
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function reeBookFailedHotel(itineraryIdentifier, passenger) {
    let deferred = $q.defer();

    $http
      .post(`${APP_CONFIG.api.url}Itinerary/${itineraryIdentifier}/rebook`, passenger)
      .then((response) => {
        service.set(response.data);
        deferred.resolve(response.data);
      })
      .catch((error) => {
        deferred.reject(error);
      });

    return deferred.promise;
  }

  function postModify(passengerId, ignorePending, modifyData) {
    let deferred = $q.defer();

    $http
      .post(`${APP_CONFIG.api.url}Itinerary/modify/${passengerId}/${ignorePending}`, modifyData)
      .then((response) => {
        const data = response.data;
        service.set(data);
        deferred.resolve(data);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function postModifyCurrent(passengerId, modifyData) {
    let deferred = $q.defer();

    $http
      .post(`${APP_CONFIG.api.url}Itinerary/modify-current/${passengerId}`, modifyData)
      .then((response) => {
        const data = response.data;
        service.set(data);
        deferred.resolve(data);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function save(data, id) {
    let deferred = $q.defer();

    let url = `${APP_CONFIG.api.itinerary}${id}`;

    $http
      .put(url, data)
      .then((response) => {
        const data = response.data;
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function find(itineraryId, passengerId, pcc) {
    let deferred = $q.defer();

    $http
      .get(`${APP_CONFIG.api.itinerary}${itineraryId}/Passenger/${passengerId}/${pcc}`, {})
      .then((response) => {
        const data = response.data;
        service.set(data);
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function findPnr(pnr, livePnrData) {
    let deferred = $q.defer();
    $http.get(`${APP_CONFIG.api.itinerary}passenger-booking/${pnr}${livePnrData === true ? '?livePnrData=true' : ''}`, {}).then(
      ({ data: data }) => {
        service.set(data.Passenger);
        if (data.Passenger && data.Modifications) {
          service.itinerary.Modifications = data.Modifications;
        }
        deferred.resolve(data);
      },
      (error) => {
        deferred.reject(error);
      }
    );
    return deferred.promise;
  }
  function findPassenger(passengerId, livePnrData) {
    let deferred = $q.defer();
    $http.get(`${APP_CONFIG.api.itinerary}passenger-booking/${passengerId}${livePnrData === true ? '?livePnrData=true' : ''}`, {}).then(
      ({ data: data }) => {
        service.set(data.Passenger);
        if (data.Passenger && data.Modifications) {
          service.itinerary.Modifications = data.Modifications;
        }
        deferred.resolve(data);
      },
      (error) => {
        deferred.reject(error);
      }
    );
    return deferred.promise;
  }

  function findOffline(pnr, pcc) {
    let deferred = $q.defer();

    $http
      .get(`${APP_CONFIG.api.itinerary}Passenger/${pnr}/${pcc}`, {})
      .then((response) => {
        const data = response.data;
        service.set(data);
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function reset() {
    sessionStorage.removeItem('itineraryId');
    service.itinerary = {};
  }

  function approveItinerary(itineraryParams) {
    return $http.post(buildQuery(itineraryParams) + '/approve');
  }

  // LOBT-2525 Frontend - My Bookings Confirm booking on hold
  function confirmItinerary(itineraryId, passengerId) {
    return $http.put(`${APP_CONFIG.api.url}itinerary/${itineraryId}/passenger/${passengerId}/confirm`);
  }
  // LOBT-2525 Frontend - My Bookings Confirm booking on hold

  function declineItinerary(itineraryParams, reason) {
    var wrappedReason = '"' + reason + '"';
    return $http.post(buildQuery(itineraryParams) + '/decline', wrappedReason, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  function getFareRules(params) {
    let deferred = $q.defer();

    $http
      .get(
        `${APP_CONFIG.api.url}itinerary/${params.itineraryId}/passenger/${params.passengerId}/${params.sectorType}/${params.sectorId}/farerules`
      )
      .then((response) => {
        const data = response.data;
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function IataSearch(params) {
    let deferred = $q.defer();

    $http
      .get('http://localhost:3004/iata', {
        params: params,
      })
      .then((response) => {
        const data = response.data;
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function locationSearch(params) {
    let deferred = $q.defer();

    $http
      .get(`${APP_CONFIG.api.url}${params.type}/locations/${params.maxRows}/${params.term}`, {
        desc: 'retrieving Airport locations from the server',
      })
      .then((response) => {
        const data = response.data;
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function buildQuery(params) {
    return `${APP_CONFIG.api.url}Approval/${params.itineraryId}/${params.passengerId}/${params.approverId}`;
  }

  function groupPost(id, items, type) {
    let searchIndexKey;
    let searchIndexIncrement = 1;

    switch (type) {
      case 'Hotels':
        searchIndexKey = 'Hotel';

        break;

      case 'Flights':
        searchIndexKey = 'Flight';

        searchIndexIncrement = service.itinerary.Search.Flights.length;

        break;

      case 'Rails':
        searchIndexKey = 'Rail';

        searchIndexIncrement = service.itinerary.Search.Rails.length;

        break;

      case 'Cars':
        searchIndexKey = 'Car';

        break;
      case 'GroundTrans':
        searchIndexKey = 'Ground';

        break;

      default:
        console.warn('No postType supplied');
    }
    // TODO switch if type is GroundTransports
    return $http
      .post(`${APP_CONFIG.api.url}Itinerary/${id}/passenger`, items)
      .then(({ data: passengers }) => {
        if (searchIndexKey === 'Flight' && service.itinerary.Search.Flights.length === 2 && service.itinerary.Search.Cars.length > 0) {
          return service.get(service.itinerary.Id);
        } else {
          service.itinerary.Passengers = passengers;
        }
      })
      .then(() => locationService.increaseSearchIndex(searchIndexKey, searchIndexIncrement));
  }

  function hotelPriceCheck(request) {
    return $http.post(`${APP_CONFIG.api.url}Hotel/PriceCheck`, request);
  }

  function deleteSector(itineraryId, passengerId, sectorId, sectorType) {
    let postType;

    switch (sectorType) {
      case 'Flights':
        postType = 'flight';
        break;
      case 'Hotels':
        postType = 'hotel';
        break;
      case 'Rails':
        postType = 'rail';
        break;
      case 'Cars':
        postType = 'car';
        break;
      case 'GroundTransports':
        postType = 'ground';
        break;
      default:
        console.warn('No postType supplied');
    }

    let deferred = $q.defer();

    $http
      .delete(`${APP_CONFIG.api.url}Itinerary/${itineraryId}/passenger/${passengerId}/${postType}/${sectorId}`)
      .then((response) => {
        service.get(itineraryId).then(() => {
          deferred.resolve();
        });
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function addItems(items, type) {
    let passengers = service.itinerary.Passengers;

    angular.forEach(service.itinerary.Search.Passengers, (passenger) => {
      let id = passenger.Identifier;
      let targetPassenger = _.find(passengers, (o) => {
        return o.Identifier === id;
      });

      targetPassenger[type] = _.concat(targetPassenger[type], items);
    });

    return {
      itineraryId: service.itinerary.Identifier,
      items: items,
      type: type,
    };
  }

  function nextStage(selectedItems) {
    locationService.nextPage(service.itinerary.Search, selectedItems);
  }

  function invalidSeatsForSector(sector) {
    let invalidSeats = [];

    if (sector.Seat && sector.Seat.Status === 'Failed') {
      invalidSeats.push(sector.Seat);
    }

    _.forEach(sector.Stops, (stop) => {
      if (stop.Seat.Status === 'Failed') {
        invalidSeats.push(stop.Seat);
      }
    });

    return invalidSeats;
  }

  function isUsingRailCard() {
    return (
      service.itinerary &&
      service.itinerary.Search &&
      _.some(service.itinerary.Search.Rails, (railSearch) => {
        return railSearch.RailCardCode;
      })
    );
  }

  function getLoyaltyPrograms(query, code, sectorType) {
    let deferred = $q.defer();

    $http
      .get(APP_CONFIG.api.loyaltyPrograms, {
        params: { q: query, code: code, sectorType: sectorType },
      })
      .then((response) => {
        const data = response.data;
        if (data) {
          const mappedData = data.map((data) => {
            data.TypeTitleValue = `${data.Type}:${data.Title}:${data.Value}`;
            return data;
          });
          deferred.resolve(mappedData);
        } else {
          deferred.reject();
        }
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function getCarSupplierLocationsByCityCode(cityCode) {
    const path = 'api/Car/depots?citycode=' + cityCode;
    return $http.get(APP_CONFIG.api.root + path);
  }
  function getCarSupplierLocations(latitude, longitude) {
    const path = 'api/Car/depots?latitude=' + latitude + '&longitude=' + longitude;
    return $http.get(APP_CONFIG.api.root + path);
  }

  function postMembership(traveler, membership) {
    return $http.post(
      APP_CONFIG.api.root + 'api/itinerary/' + traveler.ItineraryIdentifier + '/passenger/' + traveler.Identifier + '/membership',
      membership
    );
  }

  function postMemberships(traveler, memberships) {
    return $http.post(
      APP_CONFIG.api.root + 'api/itinerary/' + traveler.ItineraryIdentifier + '/passenger/' + traveler.Identifier + '/memberships',
      memberships
    );
  }

  function deleteMembership(traveler, membership) {
    const data = {};
    angular.copy(membership, data);
    delete data.traveler;
    delete data.requestDelete;
    return $http({
      method: 'DELETE',
      url: APP_CONFIG.api.root + 'api/itinerary/' + traveler.ItineraryIdentifier + '/passenger/' + traveler.Identifier + '/membership',
      data: data,
    });
  }

  function getApprovers(itineraryId) {
    let deferred = $q.defer();

    const path = 'api/itinerary/' + itineraryId + '/approvers/';
    $http.get(APP_CONFIG.api.root + path).then((response) => {
      const data = response.data;
      if (data) {
        const approvers = data.map((approver) => {
          approver.fullName = approver.FirstName + ' ' + approver.LastName;
          return approver;
        });
        deferred.resolve(approvers);
      } else {
        deferred.reject();
      }
    });

    return deferred.promise;
  }

  function getCompanyReferences(itineraryId) {
    let deferred = $q.defer();

    const path = 'api/itinerary/' + itineraryId + '/CompanyReference/';
    $http.get(APP_CONFIG.api.root + path).then((response) => {
      const data = response.data;
      if (data) {
        deferred.resolve(data);
      } else {
        deferred.reject();
      }
    });

    return deferred.promise;
  }

  function getDepartments(itineraryId) {
    let deferred = $q.defer();

    const path = 'api/itinerary/' + itineraryId + '/Department/';
    $http.get(APP_CONFIG.api.root + path).then((response) => {
      const data = response.data;
      if (data) {
        deferred.resolve(data);
      } else {
        deferred.reject();
      }
    });

    return deferred.promise;
  }

  function getCostCentres(itineraryId) {
    let deferred = $q.defer();

    const path = 'api/itinerary/' + itineraryId + '/CostCentre/';
    $http.get(APP_CONFIG.api.root + path).then((response) => {
      const data = response.data;
      if (data) {
        deferred.resolve(data);
      } else {
        deferred.reject();
      }
    });

    return deferred.promise;
  }

  function putFlight(itineraryId, paxId, flightSectorId, flightSector) {
    let deferred = $q.defer();

    $http
      .put(`${APP_CONFIG.api.url}Itinerary/${itineraryId}/Passenger/${paxId}/Flight/${flightSectorId}`, flightSector)
      .then((response) => {
        const data = response.data;
        deferred.resolve(data);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function putFlights(flightRequests) {
    let deferred = $q.defer();

    $http
      .put(`${APP_CONFIG.api.url}Itinerary/PutPassengerFlights`, flightRequests)
      .then((response) => {
        const data = response.data;
        deferred.resolve(data);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }
  function putAncillary(itineraryId, paxId, flightSectorId, flightSector) {
    let deferred = $q.defer();

    $http
      .put(`${APP_CONFIG.api.url}Itinerary/${itineraryId}/Passenger/${paxId}/Flight/${flightSectorId}/ancillary`, flightSector)
      .then((response) => {
        const data = response.data;
        deferred.resolve(data);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function putRail(itineraryId, paxId, railSectorId, railSector) {
    let deferred = $q.defer();

    $http
      .put(`${APP_CONFIG.api.url}Itinerary/${itineraryId}/Passenger/${paxId}/Rail/${railSectorId}`, railSector)
      .then((response) => {
        const data = response.data;
        deferred.resolve(data);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function computeCarbonEmissions(flight) {
    if (flight.CarbonEmissions) {
      flight.totalCarbonEmissions = flight.CarbonEmissions;
      if (flight.Stops) {
        flight.totalCarbonEmissions += _.sumBy(flight.Stops, (stop) => (stop.CarbonEmissions ? stop.CarbonEmissions : 0));
      }
    }
    return flight;
  }

  function computeBaggageOptions(flight) {
    const baggage = [];
    const ancillaryService = flight.AncillaryServices;

    for (let i = 0; i < ancillaryService.length; i++) {
      if (ancillaryService[i].Type === 'Baggage') {
        baggage.push(ancillaryService[i]);
      }
    }

    flight.baggageOptions = baggage.length > 0 ? [{ Description: 'No baggage required', Code: 'empty' }].concat(baggage) : baggage;
    return flight;
  }

  function computeSelectedBaggage(flight) {
    let baggage = null;
    const ancillaryServices = flight.AncillaryServices;

    _.forEach(ancillaryServices, function (ancillaryService) {
      if (ancillaryService.Type === 'Baggage' && ancillaryService.QuantitySelected > 0) baggage = ancillaryService;
    });

    baggage = baggage || {
      Description: 'Select Additional Baggage',
      Code: 'empty',
    };

    flight.selectedBaggage = baggage;
    flight.cachedBaggage = flight.selectedBaggage;
    return flight;
  }

  function computeTravelServiceOptions(flight) {
    const travelService = [];
    const ancillaryService = flight.AncillaryServices;

    for (let i = 0; i < ancillaryService.length; i++) {
      if (ancillaryService[i].Type === 'TravelService') {
        travelService.push(ancillaryService[i]);
      }
    }

    flight.TravelServiceOptions =
      travelService.length > 0 ? [{ Description: 'No Travel service required', Code: 'empty' }].concat(travelService) : travelService;
    return flight;
  }

  function computeSelectedTravelService(flight) {
    let travelService = null;

    const ancillaryServices = flight.AncillaryServices;
    _.forEach(ancillaryServices, function (ancillaryService) {
      if (ancillaryService.Type === 'TravelService' && ancillaryService.QuantitySelected > 0) {
        travelService = ancillaryService;
      }
    });

    travelService = travelService || {
      Description: 'Select Travel Service',
      Code: 'empty',
    };

    flight.selectedTravelService = travelService;
    flight.cachedTravelService = flight.selectedTravelService;
    return flight;
  }

  function computeSeatOptions(flight) {
    const ancillaryServices = flight.AncillaryServices;
    const stops = flight.Stops;
    let flights = [];

    const fullFlight = flight;
    const totalStops = stops.length;

    const seats = _.filter(ancillaryServices, function (service) {
      return service.Type === 'Seat';
    });

    let prevLocationCode = totalStops ? stops[0].ArrivalCode : fullFlight.Arrival.Code;

    if (seats.length) {
      flights.push({
        Flight: {
          Origin: fullFlight.Departure.Code,
          Destination: prevLocationCode,
          TravelIdentifier: generateId(fullFlight.FlightIdentifier, 0),
        },
        Seats: seats,
      });
    }

    _.forEach(stops, (stop, stopIndex) => {
      const stopSeats = _.filter(stop.AncillaryServices, function (service) {
        return service.Type === 'Seat';
      });

      if (stopSeats.length) {
        const isLastStop = stopIndex === totalStops - 1;
        const nextLocationCode = isLastStop ? fullFlight.Arrival.Code : stops[totalStops - 1].ArrivalCode;

        flights.push({
          Flight: {
            Origin: prevLocationCode,
            Destination: nextLocationCode,
            TravelIdentifier: generateId(stop.FlightIdentifier, stopIndex + 1),
          },
          Seats: stopSeats,
        });
      }
    });

    function generateId(flightId, flightIndex) {
      return fullFlight.PassengerIdentifier + flightIndex + flightId;
    }

    flight.seatOptions = flights;
    return flight;
  }

  function computeSeatPreferences(rail) {
    const seatPreferenceTypes = ENUMS.railSeatPreferenceTypes;

    rail.SeatPreferences = {};

    _.forIn(seatPreferenceTypes, (preferenceType) => {
      rail.SeatPreferences[preferenceType] = _.filter(rail.AncillaryServices, (service) => {
        return service.Type === preferenceType;
      });

      rail.SeatPreferences[preferenceType] = _.orderBy(rail.SeatPreferences[preferenceType], (service) => {
        return service.Code === 'No Preference' ? 0 : 1;
      });
    });

    return rail;
  }

  function computeSeatsTotalAmount(flight) {
    flight.seatsTotalAmount = _.reduce(
      flight.seatOptions,
      function (total, options) {
        let selectedSeat = _.find(options.Seats, function (seat) {
          return seat.QuantitySelected === 1;
        });

        return total + (selectedSeat ? selectedSeat.Amount : 0);
      },
      0
    );

    if (!!!flight.seatsTotalAmount) {
      let seatAmountCollection = flight.Stops.map((stop) => stop.Seat.SeatAmount);
      seatAmountCollection.push(0);
      flight.seatsTotalAmount = flight.Seat.SeatAmount + seatAmountCollection.reduce((a, b) => a + b);
    }

    if (!!!flight.seatsTotalAmount && !!flight.Seat.SeatNumber) {
      flight.seatsTotalAmount = flight.Seat.SeatAmount;
    }

    return flight;
  }

  function computeFlightTotalAmount(flight) {
    const ancillaryServices = flight.AncillaryServices;
    const feeAmount = flight.FeeAmount;
    const amount = flight.Amount;
    const stops = flight.Stops;
    const seatsTotalAmount = flight.seatsTotalAmount;
    const originalTicketAmount = flight.OriginalTicketAmount;
    let flightTotalAmount = 0;

    _.forEach(ancillaryServices, function (service) {
      flightTotalAmount += service.QuantitySelected * service.Amount;
    });

    _.forEach(stops, function (stop) {
      _.forEach(stop.AncillaryServices, function (service) {
        flightTotalAmount += service.QuantitySelected * service.Amount;
      });
    });

    flight.flightBaseAmount = flightTotalAmount + amount + feeAmount;
    flight.flightTotalAmount = flight.flightBaseAmount + seatsTotalAmount;
    return flight;
  }

  function computeFlightSector(sector) {
    return _.flowRight(
      computeFlightTotalAmount,
      computeSeatsTotalAmount,
      computeSeatOptions,
      computeSelectedBaggage,
      computeBaggageOptions,
      computeCarbonEmissions,
      computeTravelServiceOptions,
      computeSelectedTravelService
    )(sector);
  }

  function computePaxFlightTotalAmount(pax) {
    let CreditsUsed = 0;
    const flights = pax.Flights;

    _.forEach(flights, function (flight) {
      CreditsUsed += flight.CreditsUsed;
    });

    return CreditsUsed;
  }

  function computePaxSectors(pax) {
    const flights = pax.Flights;
    const rails = pax.Rails;
    const hotels = pax.Hotels;
    const cars = pax.Cars;
    const grounds = pax.GroundTransports;

    const noTimezoneDateFormat = 'YYYY-MM-DDTHH:mm';
    const sortingDateFormat = 'YYYYMMDDHHmm';
    const groupingDateFormat = 'YYYYMMDD';
    const groupingDateDisplayFormat = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM);

    const sectorsArray = [].concat(flights || [], rails || [], hotels || [], cars || [], grounds || []);

    for (let x = 0; x < sectorsArray.length; x++) {
      let parsedDate = null;

      try {
        if (sectorsArray[x].Departure && sectorsArray[x].Departure.Date) {
          parsedDate = moment(sectorsArray[x].Departure.Date, noTimezoneDateFormat);
        } else if (sectorsArray[x].DateFrom) {
          parsedDate = moment(sectorsArray[x].DateFrom, noTimezoneDateFormat);
        } else if (sectorsArray[x].PickUp && sectorsArray[x].PickUp.Date) {
          parsedDate = moment(sectorsArray[x].PickUp.Date, noTimezoneDateFormat);
        } else if (sectorsArray[x].StartDateTime) {
          parsedDate = moment(sectorsArray[x].StartDateTime);
        }
      } catch (err) {}

      sectorsArray[x].groupByDate = parsedDate ? parsedDate.format(sortingDateFormat) : null;
    }

    sectorsArray.sort(function (sectorA, sectorB) {
      return sectorA.groupByDate > sectorB.groupByDate ? 1 : -1;
    });

    let groupByDateString = null;
    let groupId = 0;
    let unorderedSectors = [];

    for (var y = 0; y < sectorsArray.length; y++) {
      let groupByDate = sectorsArray[y].groupByDate;
      let trimmedGroupByDate = null;
      let groupCopy = {};

      if (groupByDate) {
        trimmedGroupByDate = groupByDate.substring(0, groupByDate.length - 4);
      }

      if (trimmedGroupByDate && groupByDateString !== trimmedGroupByDate) {
        groupId++;
        groupByDateString = trimmedGroupByDate;
        sectorsArray[y].groupByDateString = moment(groupByDateString, groupingDateFormat).format(groupingDateDisplayFormat);
      }

      groupCopy = sectorsArray[y];
      groupCopy.groupId = groupId;
      unorderedSectors.push(groupCopy);
    }

    const matchGroupIds = function (array) {
      const x = [];
      angular.forEach(array, function (obj) {
        x.push(obj.groupId);
      });
      return x;
    };

    const onlyUnique = function (value, index, self) {
      return self.indexOf(value) === index;
    };

    const spiltArray = function (array, argumentArray) {
      const result = [];
      let argumentIndex = 0;
      angular.forEach(array, function (obj) {
        if (obj.groupId !== argumentArray[argumentIndex]) {
          argumentIndex++;
        }
        if (!result[argumentIndex]) {
          result[argumentIndex] = [obj];
        } else {
          result[argumentIndex].push(obj);
        }
      });
      return result;
    };

    const reorderParentChild = function (parent) {
      let ParentReordered = [];

      angular.forEach(parent, function (obj) {
        const flights = pluckNamedObjectFromArray(obj, 'Flight');
        const rails = pluckNamedObjectFromArray(obj, 'Rail');
        const hotels = pluckNamedObjectFromArray(obj, 'Hotel');
        const cars = pluckNamedObjectFromArray(obj, 'Car');
        const grounds = pluckNamedObjectFromArray(obj, 'Ground');
        let childReordered = flights.concat(rails, hotels, cars, grounds);
        ParentReordered.push(childReordered);
      });

      return ParentReordered;
    };

    const pluckNamedObjectFromArray = function (array, match) {
      let matches = [];
      angular.forEach(array, function (obj) {
        if (match === 'Flight' && obj.Carrier && !obj.RailNumber) {
          matches.push(obj);
        }
        if (match === 'Rail' && obj.RailNumber) {
          matches.push(obj);
        }
        if (match === 'Hotel' && obj.HotelName) {
          matches.push(obj);
        }
        if (match === 'Car' && obj.PickUp) {
          matches.push(obj);
        }
        if (match === 'Ground' && obj.StartDateTime) {
          matches.push(obj);
        }
      });
      return matches;
    };

    const moveAttributeToIndex = function (array, attr) {
      let val = '';

      angular.forEach(array, function (childArray, key) {
        angular.forEach(childArray, function (obj, index) {
          if (obj[attr]) {
            val = obj[attr];
            delete array[key][index][attr];
          }
          array[key][0][attr] = val;
        });
      });

      return array;
    };

    const groupsToOrder = matchGroupIds(unorderedSectors);
    const uniqueGroups = groupsToOrder.filter(onlyUnique);
    const groupByDay = spiltArray(unorderedSectors, uniqueGroups);
    const reorderSectorsInDay = reorderParentChild(groupByDay);
    const moveGroupDate = moveAttributeToIndex(reorderSectorsInDay, 'groupByDateString');

    pax.Sectors = [].concat.apply([], moveGroupDate);
    return pax;
  }

  function computePaxFlightTotal(pax) {
    const flights = pax.Flights;
    let flightTotal = 0;
    let flightBaseTotal = 0;

    _.forEach(flights, function (flight) {
      // flightTotal += flight.TotalAmount;
      flightTotal += flight.flightTotalAmount;
      flightBaseTotal += flight.flightBaseAmount;
    });

    pax.FlightTotal = flightTotal;
    pax.FlightBaseTotal = flightBaseTotal;
    return pax;
  }

  function computePaxRailTotal(pax) {
    const rails = pax.Rails;
    let railTotal = 0;

    _.forEach(rails, function (rail) {
      railTotal += rail.TotalAmount;
    });

    pax.RailTotal = railTotal;
    return pax;
  }

  function computePaxHotelTotal(pax) {
    const hotels = pax.Hotels;
    let hotelTotal = 0;

    _.forEach(hotels, function (hotel) {
      hotelTotal += hotel.TotalAmount;
    });

    pax.HotelTotal = hotelTotal;
    return pax;
  }

  function computePaxCarTotal(pax) {
    const cars = pax.Cars;
    let carTotal = 0;

    _.forEach(cars, function (car) {
      carTotal += car.TotalAmount;
    });

    pax.CarTotal = carTotal;
    return pax;
  }
  function computePaxGroundTotal(pax) {
    const grounds = pax.GroundTransports;
    let groundTotal = 0;

    _.forEach(grounds, function (ground) {
      groundTotal += ground.TotalAmount;
    });

    pax.groundTotal = groundTotal;
    return pax;
  }
  function computePaxAmount(pax) {
    const flightTotal = pax.FlightTotal;
    const RailTotal = pax.RailTotal;
    const hotelTotal = pax.HotelTotal;
    const carTotal = pax.CarTotal;
    const groundTotal = pax.groundTotal;

    pax.BaseAmount = Number(pax.FlightBaseTotal) + Number(RailTotal) + Number(hotelTotal) + Number(carTotal) + Number(groundTotal);
    pax.Amount = Number(flightTotal) + Number(RailTotal) + Number(hotelTotal) + Number(carTotal) + Number(groundTotal);

    return pax;
  }

  function computePaxFlightLostSavingsTotal(pax) {
    const flights = pax.Flights;
    let lostSavingsTotal = 0;

    _.forEach(flights, function (flight) {
      lostSavingsTotal += flight.LostSavingsAmount;
    });

    pax.RailLostSavingsTotal = lostSavingsTotal;
    return pax;
  }

  function computeRailLostSavingsTotal(pax) {
    const rails = pax.Rails;
    let lostSavingsTotal = 0;

    _.forEach(rails, function (rail) {
      lostSavingsTotal += rail.LostSavingsAmount;
    });

    pax.RailLostSavingsTotal = lostSavingsTotal;
    return pax;
  }

  function computeHotelLostSavingsTotal(pax) {
    const hotels = pax.Hotels;
    let lostSavingsTotal = 0;

    _.forEach(hotels, function (hotel) {
      lostSavingsTotal += hotel.LostSavingsAmount;
    });

    pax.CarLostSavingsTotal = lostSavingsTotal;
    return pax;
  }

  function computeCarLostSavingsTotal(pax) {
    const cars = pax.Cars;
    let lostSavingsTotal = 0;

    _.forEach(cars, function (car) {
      if (typeof car.LostSavingsAmount === 'number') {
        lostSavingsTotal += car.LostSavingsAmount;
      }
    });

    pax.CarLostSavingsTotal = lostSavingsTotal;
    return pax;
  }

  function computeLostSavingsAmount(pax) {
    pax.LostSavingsAmount =
      Number(pax.FlightLostSavingsTotal) +
      Number(pax.RailLostSavingsTotal) +
      Number(pax.HotelLostSavingsTotal) +
      Number(pax.CarLostSavingsTotal);

    return pax;
  }

  function computeCreditsUsed(pax) {
    const flights = pax.Flights;
    let creditsUsedTotal = 0;

    if (Array.isArray(flights) && flights.length) {
      _.forEach(flights, function (flight) {
        if (typeof flight.CreditsUsed === 'number') {
          creditsUsedTotal += flight.CreditsUsed;
        }
      });
    }

    pax.CreditsUsed = creditsUsedTotal;
    return pax;
  }

  function computeHasFlightSectors(pax) {
    let hasFlights = false;
    if (!!pax && !!pax.Sectors && pax.Sectors.length > 0) {
      if (pax.Pnr) {
        return false;
      }

      for (let i = 0; i < pax.Sectors.length; i++) {
        hasFlights = !!pax.Sectors[i].FlightNumber || hasFlights;
      }
    }

    pax.hasFlights = true;
    return pax;
  }

  function deletePax(paxId, itineraryId) {
    let deferred = $q.defer();

    $http
      .delete(`${APP_CONFIG.api.url}Itinerary/${itineraryId}/passenger/${paxId}`)
      .then((response) => {
        service.get(itineraryId).then((itinerary) => {
          deferred.resolve(itinerary);
        });
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function computePax(pax) {
    pax.Flights = pax.Flights.map((flight) => {
      return computeFlightSector(flight);
    });

    pax.Rails = pax.Rails.map((rail) => {
      return computeRailSector(rail);
    });

    return pax;
  }

  function computeTicketOptions(sector) {
    const ancillaryServices = sector.AncillaryServices;

    let options = _.filter(ancillaryServices, function (service) {
      return service.Type === 'Ticketing';
    });

    sector.ticketOptions = _.map(options, (option) => {
      if (option.Description === 'Collection') {
        option.Description = `Pickup on departure - ${sector.Departure.Location} (${sector.Departure.Code})`;
      }

      return option;
    });

    return sector;
  }

  function computeItineraryTotal(itinerary) {
    const travelers = itinerary.Passengers;
    let itineraryTotal = 0;

    if (Array.isArray(travelers)) {
      _.forEach(travelers, function (traveler) {
        if (typeof traveler.Amount === 'number') {
          itineraryTotal += traveler.Amount;
        }
      });
    }

    itinerary.ItineraryTotal = itineraryTotal;

    return itinerary;
  }

  function computeCreditsUsedTotal(itinerary) {
    const travelers = itinerary.Passengers;
    let totalCreditsUsed = 0;

    if (Array.isArray(travelers)) {
      _.forEach(travelers, function (traveler) {
        if (typeof traveler.CreditsUsed === 'number') {
          totalCreditsUsed += traveler.CreditsUsed;
        }
      });
    }

    itinerary.CreditsUsedTotal = totalCreditsUsed;

    return itinerary;
  }

  function computeLostSavingsTotal(itinerary) {
    const travelers = itinerary.Passengers;
    let lostSavingsTotal = 0;

    if (Array.isArray(travelers)) {
      _.forEach(travelers, function (traveler) {
        if (typeof traveler.LostSavingsAmount === 'number') {
          lostSavingsTotal += traveler.LostSavingsAmount;
        }
      });
    }

    itinerary.LostSavingsTotal = lostSavingsTotal;

    return itinerary;
  }

  function computeNonRefundableContent(itinerary) {
    const travelers = itinerary.Passengers;
    let NonRefundable = false;

    if (Array.isArray(travelers)) {
      _.forEach(travelers, function (traveler) {
        let continueLoop = true;
        _.forEach(traveler.Sectors, function (sector) {
          if (sector.Refundable === false) {
            NonRefundable = true;
            continueLoop = false;
            return false;
          }
        });

        return continueLoop;
      });
    }

    itinerary.NonRefundableContent = NonRefundable;

    return itinerary;
  }

  function computeRailSector(sector) {
    return _.flowRight(computeTicketOptions, computeSeatPreferences)(sector);
  }

  function computeItinerary(itinerary) {
    if (!itinerary.Passengers && itinerary.Passengers.length === 0) {
      return itinerary;
    }

    itinerary.Passengers.map((pax) => {
      return _.flowRight(
        computeHasFlightSectors,
        computeCreditsUsed,
        computeLostSavingsAmount,
        computeCarLostSavingsTotal,
        computeHotelLostSavingsTotal,
        computeRailLostSavingsTotal,
        computePaxFlightLostSavingsTotal,
        computePaxAmount,
        computePaxCarTotal,
        computePaxGroundTotal,
        computePaxHotelTotal,
        computePaxRailTotal,
        computePaxFlightTotal,
        computePaxSectors,
        computePax
      )(pax);
    });

    return _.flowRight(computeNonRefundableContent, computeLostSavingsTotal, computeCreditsUsedTotal, computeItineraryTotal)(itinerary);
  }
  function getModifyHotel(sectorIdentifier) {
    let modifyHotel = null;
    if (!service.itinerary || !service.itinerary.Passengers) return null;
    service.itinerary.Passengers.forEach((pax) => {
      if (pax.Hotels && pax.Hotels.length > 0) {
        pax.Hotels.forEach((hotel) => {
          if (hotel.Identifier == sectorIdentifier) {
            modifyHotel = hotel;
          }
        });
      }
    });
    return modifyHotel;
  }

  function getModifyCar(sectorIdentifier) {
    let modifyCar = null;
    if (!service.itinerary || !service.itinerary.Passengers) return null;
    service.itinerary.Passengers.forEach((pax) => {
      if (pax.Cars && pax.Cars.length > 0) {
        pax.Cars.forEach((car) => {
          if (car.Identifier == sectorIdentifier) {
            modifyCar = car;
          }
        });
      }
    });
    return modifyCar;
  }

  function intlMultiCityCheck(requestFlights, selectedPassengers, flightsChange) {
    let multiCityValidationError = false;
    if (!service.itinerary || !service.itinerary.Passengers) return multiCityValidationError;
    if (!flightsChange || flightsChange.length === 0) {
      flightsChange = [];
      if (service.itinerary.Search && service.itinerary.Search.Cancel) {
        flightsChange = service.itinerary.Search && service.itinerary.Search.Cancel;
      }
    }

    const passengersObjects =
      selectedPassengers && selectedPassengers.length > 0
        ? service.itinerary.Passengers.filter((PaxObj) => selectedPassengers.find((paxId) => paxId === PaxObj.Identifier))
        : service.itinerary.Passengers;

    passengersObjects.forEach((pax) => {
      const flights = pax.Flights.filter((flight) => flightsChange.indexOf(flight.Identifier) === -1).map((flight) => {
        return {
          Depart: flight.Departure.Code,
          Arrive: flight.Arrival.Code,
          Intl: flight.Departure.IsInternational || flight.Arrival.IsInternational,
        };
      });
      var allPaxFlights = [...requestFlights, ...flights];
      if (intlMultiCityCheckSegments(allPaxFlights)) {
        multiCityValidationError = true;
      }
    });
    return multiCityValidationError;
  }
  function intlMultiCityCheckSegments(allPaxFlights) {
    let multiCityValidationError = false;
    var hasIntl = allPaxFlights.find((flight) => flight.Intl === true);

    if (hasIntl && allPaxFlights.length > 2) {
      multiCityValidationError = true;
    }
    if (
      hasIntl &&
      allPaxFlights.length === 2 &&
      (allPaxFlights[0].Depart !== allPaxFlights[1].Arrive || allPaxFlights[1].Depart !== allPaxFlights[0].Arrive)
    ) {
      multiCityValidationError = true;
    }
    return multiCityValidationError;
  }

  function repeatingCityCheckSegments(allPaxFlights) {
    if (allPaxFlights.length < 2) {
      return false;
    }
    for (var s = 0; s < allPaxFlights.length; s++) {
      if (allPaxFlights.filter((flight) => flight.Depart === allPaxFlights[s].Depart).length > 1) {
        return true;
      }
    }
    return false;
  }

  function isSameArrivalAndDeparture(allPaxFlights) {
    var hasSameArriveAndDepart = false;
    allPaxFlights.forEach((f) => {
      if (f.Arrive == f.Depart) hasSameArriveAndDepart = true;
    });

    return hasSameArriveAndDepart;
  }

  function areSameCompanyReferences(travelers) {
    const flattenedTravelers = travelers.map((x) => x.Configurations.CompanyReferences);

    function compareArrays(array1, array2) {
      if (array1.length !== array2.length) {
        return false;
      }

      for (let i = 0; i < array1.length; i++) {
        if (array1[i] !== array2[i]) {
          return false;
        }
      }

      return true;
    }

    function compareObjects(obj1, obj2) {
      // Both can be undefined
      if (!obj1 && !obj2) {
        return true;
      }

      // One can be undefined and the other doesn't
      if ((!obj1 && obj2) || (obj1 && !obj2)) {
        return false;
      }

      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (let key of keys1) {
        // We have to remove the hash key since it's always different
        if (key === '$$hashKey') {
          continue;
        }
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }

      return true;
    }

    // Iterate over each CompanyReference and check if they have any difference
    for (let traveler1 = 0; traveler1 < flattenedTravelers.length; traveler1++) {
      let traveler1CompanyReferences = flattenedTravelers[traveler1];
      for (let traveler2 = traveler1 + 1; traveler2 < flattenedTravelers.length; traveler2++) {
        let traveler2CompanyReferences = flattenedTravelers[traveler2];

        for (
          let traveler1CompanyReference = 0;
          traveler1CompanyReference < traveler1CompanyReferences.length;
          traveler1CompanyReference++
        ) {
          let traveler1CompanyReference = traveler1CompanyReferences[traveler1CompanyReference];

          let match = traveler2CompanyReferences.some(
            (x) =>
              x.Code === traveler1CompanyReference.Code &&
              x.Title === traveler1CompanyReference.Title &&
              x.Value === traveler1CompanyReference.Value &&
              compareObjects(traveler1CompanyReference.ValueDescription, x.ValueDescription)
          );

          if (!match) {
            return false; // If the item doesn't match, means there was an update in one traveler
          }
        }
      }
    }

    // If no matches were found, return false
    return true;
  }

  function setPrevNextMethods($scope, settingsService, page, modalScope) {
    var prev, next;
    let pages = [];
    pages.push({
      Name: 'paymentMethod',
      prev: settingsService.settings.Department.Enabled ? $scope.modalDepartment : $scope.modalCostCentre,
      enabled: true,
      model: $scope.modalPaymentMethod,
    });
    pages.push({
      Name: 'unusedTicketCredit',
      enabled: settingsService.isUnusedCreditEnabled() && $scope.hasUnusedTicketCredit(modalScope),
      model: $scope.modalUnusedCredit,
    });
    let isModifying = $scope.isModifyItinerary();
    pages.push({
      Name: 'companyReference',
      enabled:
        !isModifying &&
        $scope.itinerary.travelerConfigurations.companyReferences &&
        $scope.itinerary.travelerConfigurations.companyReferences.length > 0,
      model: $scope.modalCompanyReference,
    });
    pages.push({
      Name: 'approvers',
      enabled: service.hasApprovalRequired(),
      model: $scope.modalApprovers,
    });
    let pageIndex = pages.indexOf(pages.find((p) => p.Name == page));
    if (pageIndex == -1) {
      modalScope.modals = {
        PreviousMethod: prev,
        NextMethod: next,
      };
      return;
    }
    prev = pages[pageIndex].prev;
    next = pages[pageIndex].next;
    for (var p = pageIndex - 1; p >= 0; p--) {
      if (!pages[p] || !pages[p].enabled) continue;
      prev = pages[p].model;
      break;
    }
    for (var p = pageIndex + 1; p < pages.length; p++) {
      if (!pages[p] || !pages[p].enabled) continue;
      next = pages[p].model;
      break;
    }
    modalScope.modals = {
      PreviousMethod: !prev ? null : prev,
      NextMethod: !next ? null : next,
    };
    return;
  }
  function getModificationsSettings() {
    if (service.itinerary && service.itinerary.Modifications) {
      return service.itinerary.Modifications;
    }
    return settingsService.settings.Modifications;
  }
  function isModifyItinerary() {
    if (service.itinerary) {
      return service.itinerary.CreationType == ENUMS.itineraryCreationType.Modification;
    }
    return false;
  }
  function hasApprovalRequired() {
    let hasApproval = false;
    if (service.itinerary) {
      if (service.isModifyItinerary()) {
        return false;
      }
      if (service.itinerary.Passengers) {
        service.itinerary.Passengers.forEach((pax) => {
          if (['Passive', 'PreTrip'].indexOf(pax.ApprovalLevel) !== -1) {
            hasApproval = true;
          }
        });
      }
    }
    return hasApproval;
  }

  function setStayInformedOfChangesSection(errorMessages, traveler) {
    var collectContactInformationForNDCBookings = settingsService.settings.FlightConfiguration.CollectContactInformationForNDCBookings;

    if (collectContactInformationForNDCBookings) {
      const travelerFullname = traveler.Firstname + ' ' + traveler.Lastname;

      if (traveler.Configurations.PassengerContactInfo) {
        traveler.Configurations.PassengerContactInfo.emailValidationErrorMessage = null;
        traveler.Configurations.PassengerContactInfo.mobilePhoneValidationErrorMessage = null;
        traveler.Configurations.PassengerContactInfo.hasContactEmailError = false;
        traveler.Configurations.PassengerContactInfo.hasConfirmContactEmailError = false;
        traveler.Configurations.PassengerContactInfo.hasMobilePhoneError = false;
      }

      // Email errors
      if (
        traveler.Configurations.PassengerContactInfo &&
        traveler.Configurations.PassengerContactInfo.ContactEmailShare &&
        (!traveler.Configurations.PassengerContactInfo.contactEmailModel ||
          !traveler.Configurations.PassengerContactInfo.confirmContactEmail)
      ) {
        errorMessages.push(
          travelerFullname +
            " has 'Email' checked for notifications and requires both 'Email address' and 'Confirm email address' to be filled"
        );
        traveler.Configurations.PassengerContactInfo.emailValidationErrorMessage =
          "Email notifications require both 'Email address' and 'Confirm email address'";

        if (!traveler.Configurations.PassengerContactInfo.contactEmailModel) {
          traveler.Configurations.PassengerContactInfo.hasContactEmailError = true;
        }

        if (!traveler.Configurations.PassengerContactInfo.confirmContactEmail) {
          traveler.Configurations.PassengerContactInfo.hasConfirmContactEmailError = true;
        }
      } else if (
        traveler.Configurations.PassengerContactInfo &&
        traveler.Configurations.PassengerContactInfo.ContactEmailShare &&
        traveler.Configurations.PassengerContactInfo.contactEmailModel != traveler.Configurations.PassengerContactInfo.confirmContactEmail
      ) {
        errorMessages.push(travelerFullname + "'s 'Email address' and 'Confirm email address' for notifications do not match");
        traveler.Configurations.PassengerContactInfo.emailValidationErrorMessage =
          "'Email address' and 'Confirm email address' do not match";
        traveler.Configurations.PassengerContactInfo.hasContactEmailError = true;
        traveler.Configurations.PassengerContactInfo.hasConfirmContactEmailError = true;
      } else if (
        traveler.Configurations.PassengerContactInfo &&
        traveler.Configurations.PassengerContactInfo.ContactEmailShare &&
        traveler.Configurations.PassengerContactInfo.contactEmailModel.length > 200
      ) {
        errorMessages.push(travelerFullname + "'s 'Email address' cannot be longer than 200 characters");
        traveler.Configurations.PassengerContactInfo.emailValidationErrorMessage = "'Email address' cannot be longer than 200 characters";
        traveler.Configurations.PassengerContactInfo.hasContactEmailError = true;
        traveler.Configurations.PassengerContactInfo.hasConfirmContactEmailError = true;
      }

      var cleanInternationalMobileNumber = '';
      if (traveler.Configurations.PassengerContactInfo.contactMobile) {
        cleanInternationalMobileNumber = traveler.Configurations.PassengerContactInfo.contactMobile.replace(/\D/g, '');
      }

      var cleanMobileNumberWithoutCountryCode = '';
      if (traveler.Configurations.PassengerContactInfo.phoneNumber) {
        cleanMobileNumberWithoutCountryCode = traveler.Configurations.PassengerContactInfo.phoneNumber.toString().replace(/\D/g, '');
      }

      // Mobile errors
      if (
        traveler.Configurations.PassengerContactInfo &&
        traveler.Configurations.PassengerContactInfo.ContactMobileShare &&
        !traveler.Configurations.PassengerContactInfo.contactMobile
      ) {
        errorMessages.push(travelerFullname + " has 'Text Message' checked for notifications, but no phone number was provided");
        traveler.Configurations.PassengerContactInfo.mobilePhoneValidationErrorMessage = 'Text notifications require a phone number';
        traveler.Configurations.PassengerContactInfo.hasMobilePhoneError = true;
      } else if (
        traveler.Configurations.PassengerContactInfo &&
        traveler.Configurations.PassengerContactInfo.ContactMobileShare &&
        cleanMobileNumberWithoutCountryCode.length < 10
      ) {
        errorMessages.push(travelerFullname + "'s 'Cell phone number' cannot be shorter than 10 characters");
        traveler.Configurations.PassengerContactInfo.mobilePhoneValidationErrorMessage =
          "'Cell phone number' cannot be shorter than 10 characters";
        traveler.Configurations.PassengerContactInfo.hasMobilePhoneError = true;
      } else if (
        traveler.Configurations.PassengerContactInfo &&
        traveler.Configurations.PassengerContactInfo.ContactMobileShare &&
        cleanInternationalMobileNumber.length > 15
      ) {
        errorMessages.push(
          travelerFullname + "'s 'Country Code' and 'Cell Phone number' combined (numerical) cannot be longer than 15 characters"
        );
        traveler.Configurations.PassengerContactInfo.mobilePhoneValidationErrorMessage =
          "'Country Code' and 'Cell Phone number' combined (numerical) cannot be longer than 15 characters";
        traveler.Configurations.PassengerContactInfo.hasMobilePhoneError = true;
      }

      if (
        errorMessages.length == 0 &&
        traveler.Configurations.PassengerContactInfo &&
        traveler.Configurations.PassengerContactInfo.ContactEmailShare &&
        traveler.Configurations.PassengerContactInfo.contactEmailModel == traveler.Configurations.PassengerContactInfo.confirmContactEmail
      ) {
        traveler.Configurations.PassengerContactInfo.ContactEmail = traveler.Configurations.PassengerContactInfo.contactEmailModel;
      }

      if (
        errorMessages.length == 0 &&
        traveler.Configurations.PassengerContactInfo &&
        traveler.Configurations.PassengerContactInfo.ContactMobileShare &&
        traveler.Configurations.PassengerContactInfo.contactMobile
      ) {
        traveler.Configurations.PassengerContactInfo.ContactMobile = traveler.Configurations.PassengerContactInfo.contactMobile;
      }
    }
  }

  return service;
};

itinerariesService.$inject = $inject;

export default itinerariesService;



// WEBPACK FOOTER //
// ./src/services/itinerariesService.js